export function isMiddlewareSkipped(middlewareName, route) {
  const { skipMiddleware } = route.params
  if (!Array.isArray(skipMiddleware)) return false

  return skipMiddleware.includes(middlewareName)
}
